/*
 * File: form-file.ts
 * File Created: 2024-02-17 07:40:57
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 12:34:39
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import { PropInnateSync } from "@root/core/vue-props";
import { IInputFileUnit } from "@root/components/inputs/input-file/lib/core";
import { UITag } from "@root/core/tags";
import { StringHelper, lang } from "@root/core";
import {
    makeRequiredValidator,
    makeValidator,
} from "@root/core/decorators/make-validator";

@Component
@UITag.setDefault({
    uiRelationConnect: true,
})
export default class FormFile extends BaseFormComponent {
    @PropInnateSync("value", { type: [Object, Array], default: undefined })
    innateValue!: IInputFileUnit | IInputFileUnit[] | undefined;

    /// "10MB" / 1024768
    @Prop({ type: [Number, String], required: false })
    limit: string | number | undefined;

    // required validation for file
    @makeRequiredValidator({
        validator: (o) =>
            !(o.value == null || (Array.isArray(o.value) && o.value.length == 0)),
    })
    defaultRequired() {
        return undefined;
    }

    /// validate size
    @makeValidator({
        validator: function (this: FormFile, o) {
            const value = o.value;
            const size = value.size;
            if (this.limit === undefined) return true;

            /// get the size and limit
            const limit =
                typeof this.limit === "number"
                    ? this.limit
                    : StringHelper.toNumber(this.limit);
            if (limit == null) return true;

            /// compare the limit
            if (size <= limit) return true;

            return false;
        },
        message: function (this: FormFile) {
            return lang.translate("w_FileExceedLimit", { limit: this.limit });
        },
    })
    defaultValidator() {
        return undefined;
    }
}
